<template>
  <base-join-challenge :on-click="() => challengeStore.addParticipant()" />
</template>

<script lang="ts" setup>

import BaseJoinChallenge from './BaseJoinChallenge.vue';
import { useChallengeStore } from '../../stores/challenge';

const challengeStore = useChallengeStore();

</script>
